import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bstime-picker',
	templateUrl:'./BSTimePickerPluginCompPage.html',
	styles: [],
	styleUrls:['./BSTimePickerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSTimePickerPluginCompPage
{
	mdContent_871 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.timepicker.BSTimePicker;
\`\`\``;
	mdContent_872 = `\`\`\`java
BSTimePicker()
\`\`\``;
	mdContent_873 = `\`\`\`java
BSTimePicker&lt;?&gt; tp = new BSTimePicker&lt;&gt;();
tp.setMeridian(true);
tp.setSeconds(true);
tp.setMinuteStep(15);
\`\`\``;
}
